import React from "react";
import PayoutWorkspace from "./PayoutWorkspace";
const ApprovePayout = props => <PayoutWorkspace mode="approve" history={props.history} />;
export default ApprovePayout;
